
import React, { useState } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
// import Success from "./Success";
import Contract from "./Request-Contract";
import ProjectEditContract from "./Project-Contract";

const RequestContract = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [step, setStep] = useState(1);

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  const handleStep = (e) => {
    e.preventDefault();
    setStep(step + 1)
  }

  return (
    <>
      <div className="g-sidenav-show bg-gray-100 min-vh-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar} handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />
            <div className="header header-bg-lender">
              <div className="Contrcat-conatiner">
{step===1 &&
 <Contract handleStep={handleStep}/>
}
{step===2 &&
 <ProjectEditContract handleStep={handleStep} />
}
             
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  )
}
export default RequestContract; 